// Frontend API client - calls backend endpoints only
const API_BASE_URL = ''; // Endpoint-uri /api/* în Vercel

// Funcție de normalizare URL
function normalizeUrl(url: string): string {
  const trimmed = url.trim();
  
  // Dacă nu începe cu http:// sau https://, adaugă https://
  if (!trimmed.startsWith('http://') && !trimmed.startsWith('https://')) {
    return `https://${trimmed}`;
  }
  
  return trimmed;
}

export class ApiClient {
  // Scanare site - POST /api/scan
  static async scanSite(url: string): Promise<any> {
    // Clean and normalize URL
    const cleanUrl = url.startsWith('http') ? url : 'https://' + url;
    
    const response = await fetch(`${API_BASE_URL}/api/scan`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ url: cleanUrl }),
    });

    if (!response.ok) {
      const text = await response.text();
      let errorData;
      
      try {
        errorData = JSON.parse(text);
      } catch {
        // If not JSON, use first 120 chars of text
        throw new Error(`HTTP ${response.status}: ${text.substring(0, 120)}${text.length > 120 ? '...' : ''}`);
      }
      
      // Prioritize error fields: error > message > fallback
      const errorMessage = errorData.error || errorData.message || `HTTP ${response.status}`;
      throw new Error(errorMessage);
    }

    const text = await response.text();
    try {
      const parsed = JSON.parse(text);
      // Ensure we never return undefined
      if (!parsed) {
        throw new Error('Empty response from server');
      }
      return parsed;
    } catch {
      throw new Error(`Invalid JSON response: ${text.substring(0, 120)}${text.length > 120 ? '...' : ''}`);
    }
  }
}
